// Autogenerated file, DO NOT MODIFY or it will be overwritten;
import type { SVGProps } from 'react';

import { forwardRef } from '@chakra-ui/react';

import { Icon, type IconProps } from '../Icon';

const Svg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 51 50"
    {...props}
  >
    <g filter="url(#a)">
      <circle cx={25.5} cy={25} r={25} fill="url(#b)" />
    </g>
    <path
      fill="url(#c)"
      d="M18.1136 13.6364C18.1136 13.0088 17.6049 12.5 16.9773 12.5C16.3497 12.5 15.8409 13.0088 15.8409 13.6364V15.3409H14.1364C13.5088 15.3409 13 15.8497 13 16.4773C13 17.1049 13.5088 17.6136 14.1364 17.6136H15.8409V19.3182C15.8409 19.9458 16.3497 20.4545 16.9773 20.4545C17.6049 20.4545 18.1136 19.9458 18.1136 19.3182V17.6136H19.8182C20.4458 17.6136 20.9545 17.1049 20.9545 16.4773C20.9545 15.8497 20.4458 15.3409 19.8182 15.3409H18.1136V13.6364Z"
    />
    <path
      fill="url(#d)"
      d="M18.1136 30.6818C18.1136 30.0542 17.6049 29.5455 16.9773 29.5455C16.3497 29.5455 15.8409 30.0542 15.8409 30.6818V32.3864H14.1364C13.5088 32.3864 13 32.8951 13 33.5227C13 34.1503 13.5088 34.6591 14.1364 34.6591H15.8409V36.3636C15.8409 36.9912 16.3497 37.5 16.9773 37.5C17.6049 37.5 18.1136 36.9912 18.1136 36.3636V34.6591H19.8182C20.4458 34.6591 20.9545 34.1503 20.9545 33.5227C20.9545 32.8951 20.4458 32.3864 19.8182 32.3864H18.1136V30.6818Z"
    />
    <path
      fill="url(#e)"
      d="M27.697 14.3648C27.5282 13.9259 27.1066 13.6364 26.6364 13.6364C26.1662 13.6364 25.7445 13.9259 25.5757 14.3648L23.6051 19.4885C23.2637 20.3761 23.1564 20.6318 23.0097 20.8382C22.8625 21.0452 22.6816 21.2261 22.4745 21.3734C22.2682 21.5201 22.0124 21.6274 21.1249 21.9687L16.0012 23.9394C15.5623 24.1082 15.2727 24.5298 15.2727 25C15.2727 25.4702 15.5623 25.8918 16.0012 26.0606L21.1249 28.0313C22.0124 28.3726 22.2682 28.4799 22.4745 28.6266C22.6816 28.7739 22.8625 28.9548 23.0097 29.1618C23.1565 29.3682 23.2637 29.6239 23.6051 30.5115L25.5757 35.6352C25.7445 36.0741 26.1662 36.3636 26.6364 36.3636C27.1066 36.3636 27.5282 36.0741 27.697 35.6352L29.6676 30.5115C30.009 29.6239 30.1163 29.3682 30.263 29.1618C30.4102 28.9548 30.5911 28.7739 30.7982 28.6266C31.0045 28.4799 31.2603 28.3726 32.1479 28.0313L37.2716 26.0606C37.7104 25.8918 38 25.4702 38 25C38 24.5298 37.7104 24.1082 37.2716 23.9394L32.1479 21.9687C31.2603 21.6274 31.0045 21.5201 30.7982 21.3734C30.5911 21.2261 30.4102 21.0452 30.263 20.8382C30.1163 20.6318 30.009 20.3761 29.6676 19.4885L27.697 14.3648Z"
    />
    <defs>
      <linearGradient
        id="b"
        x1={1.068}
        x2={51.068}
        y1={-17.614}
        y2={67.046}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" />
        <stop offset={1} stopColor="#fff" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="c"
        x1={6.182}
        x2={64.136}
        y1={0}
        y2={77.841}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#6421B9" />
        <stop offset={1} stopColor="#6421B9" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="d"
        x1={6.182}
        x2={64.136}
        y1={0}
        y2={77.841}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#6421B9" />
        <stop offset={1} stopColor="#6421B9" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="e"
        x1={6.182}
        x2={64.136}
        y1={0}
        y2={77.841}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#6421B9" />
        <stop offset={1} stopColor="#6421B9" stopOpacity={0} />
      </linearGradient>
      <filter
        id="a"
        width={54.545}
        height={54.545}
        x={-4.045}
        y={-4.545}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dx={-4.545} dy={-4.545} />
        <feGaussianBlur stdDeviation={4.545} />
        <feComposite in2="hardAlpha" k2={-1} k3={1} operator="arithmetic" />
        <feColorMatrix values="0 0 0 0 0.392157 0 0 0 0 0.129412 0 0 0 0 0.72549 0 0 0 0.1 0" />
        <feBlend in2="shape" result="effect1_innerShadow_2394_20937" />
      </filter>
    </defs>
  </svg>
);
const IconTripleStarCircle = forwardRef(
  (props: Omit<IconProps, 'icon'>, ref) => {
    return <Icon ref={ref} icon={Svg} {...props} />;
  }
);
export default IconTripleStarCircle;
